import { Alert, List, ListItem } from '@mui/material'
import { useInView } from 'react-cool-inview'
import { DelayedLoader } from '../DelayedLoader'

interface InfiniteListProps<T> {
  loading?: boolean
  list?: T[]
  emptyListLabel?: string
  renderFn: (listItem: T, index: number) => JSX.Element
  onLoadMore: () => void
}

export const InfiniteList = <T extends unknown>({
  loading,
  list,
  emptyListLabel,
  renderFn,
  onLoadMore,
}: InfiniteListProps<T>) => {
  const { observe } = useInView({
    rootMargin: '50px',
    onEnter: ({ unobserve }) => {
      unobserve()
      onLoadMore()
    },
  })

  if (loading) {
    return <DelayedLoader />
  }

  return (
    <>
      {list ? (
        list.length > 0 ? (
          <List sx={{ pb: '45px', pt: 0 }}>
            {list.map((item: any, index: number) => (
              <ListItem key={index} disablePadding ref={index === list.length - 1 ? observe : null}>
                {renderFn(item, index)}
              </ListItem>
            ))}
          </List>
        ) : (
          <>{emptyListLabel && <Alert severity="info">Nav neviena ieraksta</Alert>}</>
        )
      ) : (
        <></>
      )}
    </>
  )
}
